import { Box } from "@mui/material";

interface ApplicationWrapperProps {
  children: React.ReactNode;
}

export default function ApplicationWrapper(props: ApplicationWrapperProps): React.ReactElement {
  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      sx={{ background: "rgba(211, 211, 211, 0.1)" }}
    >
      {props.children}
    </Box>
  );
}
